import Home from './Home'
import About from './About'
import News from './News'
import Teacher from './Tealist'
import Header from './Header'
import Wisdom from './Wisdom'
import NewHome from './NewHome'


const Api = {
  Home,
  About,
  News,
  Teacher,
  Header,
  Wisdom,
  NewHome
}

// 导出
export default Api
